<template>
  <div class="pa-card-field" ref="cardField">
    <div class="pa-card">
      <div class="pa-card-content">
        <div class="card-row card-row-city-logo">
          <PACityLogo />
        </div>
        
        <div class="card-row card-row-city-name">
          <PACityName />
        </div>

        <div class="card-row card-row-card-name">
          <PACardName />
        </div>

        <div class="card-row card-row-card-desc">
          <PACardDesc />
        </div>

        <div class="card-row card-row-card-direction">
          <PACardDirection />
        </div>

        <div class="card-row card-row-right card-row-card-copy">
          <PACardCopy />
        </div>
      </div>
      
      <div class="pa-card-background">
        <PACardBackground />
      </div>
    </div>
  </div>
</template>

<script>
import PACityLogo       from '@/components/Parts/PACard/images/city-logo.svg?inlineN'
import PACityName       from '@/components/Parts/PACard/images/city-name.svg?inlineN'
import PACardName       from '@/components/Parts/PACard/images/card-name.svg?inlineN'
import PACardDesc       from '@/components/Parts/PACard/images/card-desc.svg?inlineN'
import PACardDirection  from '@/components/Parts/PACard/images/card-direction.svg?inlineN'
import PACardCopy       from '@/components/Parts/PACard/images/copy.svg?inlineN'

import PACardBackground from '@/components/Parts/PACard/images/card-background.svg?inlineN'

export default {
  components : {
    PACityLogo,
    PACityName,
    PACardName,
    PACardDesc,
    PACardDirection,
    PACardCopy,

    PACardBackground
  },
}
</script>

<style lang="scss">
@import "~bulma/bulma.sass";

.pa-card-field{
  width:calc((100vh / 1.2) * 1.68);
  height:calc((100vh / 1.2) * 1);
  margin:0 auto;
  border-radius: 10px;
  background-color: #87395A;
  box-shadow: 1px 1px 10px #7D3253;

  .pa-card{
    width:100%;
    height:100%;
    border-radius: 10px;
    position: relative;

    &-content{
      position: absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      padding:.5rem;
      
      .card-row{
        text-align:center;

        svg{
          fill:#40071c;
        }

        &-city-logo{
          svg{
            width:4rem;
          }
        }

        &-city-name{
          svg{
            width:8rem;
          }
        }

        &-card-name{
          svg{
            width:95%;
          }
        }

        &-card-desc{
          svg{
            width:95%;
          }
        }

        &-card-direction{
          margin-top:.2rem;
          svg{
            width:98%;
          }
        }

        &-card-copy{
          width:100%;
          position: absolute;
          right:.5rem;
          bottom:.2rem;
          text-align: right;

          svg{
            width:50%;
          }
        }

      }
    }

    &-background{
      content: " ";
      width:100%;
      height:100%;
      overflow: hidden;
      border-radius: 10px;
      
      svg{
        margin-top:-5%;
        margin-left:-20px;
        width:120%;
        height:120%;
        fill:rgba(101, 41, 70, .4);
      }
    }
  }

  @include until(440px) {
    display: none;
  }

  @include from(700px) {
    width:calc(380px * 1.68);
    height:calc(380px * 1);
  }

  @include from($tablet) {
    width:calc(375px * 1.68);
    height:calc(375px * 1);

    .pa-card{
      &-content{
        .card-row{
          &-city-logo{
            svg{
              width:5.5rem;
            }
          }

          &-city-name{
            svg{
              width:10rem;
            }
          }

          &-card-name{
            margin:.3rem 0;
          }
        }
      }
    }
  }
}
</style>